import { Button } from "@/components/Button"
import { Input } from "@/components/Form/Input"
import { useRainCorporateFormContext, VALID_EMAIL } from "@usher/pe-client-front-end-lib"
import { useHistory } from "react-router-dom"

const ContactDetails = () => {
  const history = useHistory()
  const { formMethods, submitLoading } = useRainCorporateFormContext()
  const { control, handleSubmit } = formMethods

  return (
    <div className="">
      <h1 className="text-2xl text-black mb-4">Add Company Contact Detail</h1>
      <form noValidate autoComplete="off" onSubmit={handleSubmit(() => history.push("/company-verification/form/documents"))}>
        <label className="mb-1">Phone Number</label>
        <Input.Phone disabled withFlag name="company_info.corp_phone" control={control} />
        <label className="mt-2.5 mb-1">Email</label>
        <Input.Form disabled name="company_info.email" control={control} required rules={VALID_EMAIL} />

        <div className="flex justify-end mt-4">
          <Button className="w-full" loading={submitLoading.company_info}>
            Continue
          </Button>
        </div>
      </form>
    </div>
  )
}

export default ContactDetails
